/* =========================================
   BEST LEARNING — Theme JS v1.1
   ========================================= */

/* =========================================================================
   SHARED CAROUSEL ENGINE — BLSwipe + BLCarousel
   Top level on purpose. The product IIFE below returns early on any page
   without .product-page, so anything defined inside it does not exist on the
   homepage. BLSwipe used to live in there, which is why the drag-follow
   guards in reviews.liquid and shop-by-age.liquid silently did nothing.
   ========================================================================= */
(function () {
  'use strict';

  /* ===== BLSwipe — drag-follow touch =====
     The track follows the finger in real time instead of jumping on release,
     which is the movement feedback the peek layout implies. Behaviour is
     unchanged from the original; only its location moved.

     api.get()  -> current index
     api.max()  -> highest reachable index
     api.go(i)  -> commit to index i (the caller re-applies its own transform)
     api.step() -> pixels travelled per index                                */
  window.BLSwipe = function (area, track, api) {
    if (!area || !track || !api) return;

    var startX = 0, startY = 0, dx = 0, base = 0, step = 0, t0 = 0;
    var dragging = false, locked = false;

    function onStart(e) {
      if (e.touches.length > 1) return;          /* let pinch-zoom through */
      step = api.step();
      if (!step) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0; dragging = true; locked = false;
      base = -api.get() * step;
      t0 = Date.now();
      track.style.transition = 'none';
    }

    function onMove(e) {
      if (!dragging) return;
      var mx = e.touches[0].clientX - startX;
      var my = e.touches[0].clientY - startY;

      if (!locked) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        /* vertical intent wins, so the page can still scroll */
        if (Math.abs(my) > Math.abs(mx)) { cancel(); return; }
        locked = true;
      }

      e.preventDefault();
      dx = mx;
      var i = api.get();
      var atStart = (i <= 0 && dx > 0);
      var atEnd   = (i >= api.max() && dx < 0);

      if (atStart || atEnd) {
        if (api.wrap) {
          /* A wrapping carousel has no "end" to resist, but there is also no
             slide rendered past the last one — rubber-banding would expose
             blank track. So hold the track still and remember the intent;
             onEnd still commits the wrap. */
          track.style.transform = 'translateX(' + base + 'px)';
          return;
        }
        dx *= 0.35;                 /* non-wrapping: rubber-band resistance */
      }
      track.style.transform = 'translateX(' + (base + dx) + 'px)';
    }

    function cancel() {
      dragging = false;
      track.style.transition = '';
      track.style.transform = '';
      api.go(api.get());
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';

      var elapsed = Date.now() - t0;
      var velocity = Math.abs(dx) / (elapsed || 1);
      var i = api.get();

      /* commit on either a long drag or a short flick */
      if (Math.abs(dx) > step * 0.2 || velocity > 0.4) {
        api.go(dx < 0 ? i + 1 : i - 1);
      } else {
        api.go(i);
      }
    }

    area.addEventListener('touchstart', onStart, { passive: true });
    area.addEventListener('touchmove', onMove, { passive: false });
    area.addEventListener('touchend', onEnd);
    area.addEventListener('touchcancel', cancel);
  };

  /* ===== BLCarousel — index, dots, arrows, autoplay, swipe =====
     One engine for every track-and-transform carousel in the theme.

     Layout is NOT described to this engine. It measures the rendered slide
     and reads the gutter from computed style, so the CSS breakpoint ladder
     stays the single source of truth and no slides-per-view number is ever
     duplicated in JS. Two gutter models both work: an outer margin (like
     .review-slide) or padding inside the slide (like .age-slide), which
     reports a margin of 0 and folds the gutter into offsetWidth.

     opts.track           required — the flex track that gets transformed
     opts.viewport        the overflow:hidden element (default track.parentElement)
     opts.root            hover/touch pause target (default viewport)
     opts.slides          NodeList or array (default track.children)
     opts.prev/.next      arrow buttons, hidden automatically when unreachable
     opts.dots            container; buttons are built to fit the viewport
     opts.dotClass        e.g. 'review-dot'
     opts.dotActiveClass  e.g. 'review-dot--active'
     opts.dotLabel        aria-label prefix, index appended
     opts.wrap            single-slide mode: max() is total-1 and BLSwipe
                          holds still at the ends instead of rubber-banding
     opts.loop            default true — past either end returns to the other
     opts.autoplay        boolean
     opts.speed           ms between advances
     opts.onChange        fn(index) after every commit

     Returns { get, max, go, next, prev, start, stop, refresh, step }.       */
  window.BLCarousel = function (opts) {
    opts = opts || {};

    var track = opts.track;
    if (!track) return null;

    var viewport = opts.viewport || track.parentElement;
    var root     = opts.root || viewport;
    var slides   = opts.slides
                 ? Array.prototype.slice.call(opts.slides)
                 : Array.prototype.slice.call(track.children);
    var total    = slides.length;
    if (!total) return null;

    var wrap     = !!opts.wrap;
    /* loop is separate from wrap: wrap changes how far the track can travel
       and tells BLSwipe not to rubber-band, loop only decides what happens
       once an end is reached. Default on — every existing carousel looped. */
    var loop     = (opts.loop === undefined) ? true : !!opts.loop;
    var speed    = parseInt(opts.speed, 10) || 0;
    var autoplay = !!opts.autoplay && speed > 0;

    var current = 0;
    var dots    = [];
    var timer   = null;
    var resizeT = null;

    /* ---------- measurement ---------- */

    /* Gutter as an outer margin first, then a flex gap on the track. A slide
       that carries its gutter as internal padding reports 0 for both, which
       is correct: offsetWidth already includes it. */
    function gutter() {
      var cs = window.getComputedStyle(slides[0]);
      var m  = parseFloat(cs.marginRight) || 0;
      if (m) return m;
      var tcs = window.getComputedStyle(track);
      return parseFloat(tcs.columnGap) || parseFloat(tcs.gap) || 0;
    }

    function step() {
      var w = slides[0].offsetWidth;
      return w ? w + gutter() : 0;
    }

    /* How many slides the viewport shows, derived rather than declared.
       Rounding absorbs the peek layout: an 86% slide gives ~1.16 -> 1. */
    function perView() {
      var s = step();
      if (!s || !viewport) return 1;
      return Math.max(1, Math.round(viewport.offsetWidth / s));
    }

    /* Last index that still fills the viewport, so the final view never
       shows blank slots. A wrapping carousel moves one slide at a time. */
    function max() {
      return wrap ? total - 1 : Math.max(0, total - perView());
    }

    /* ---------- painting ---------- */

    function paintDots() {
      var cls = opts.dotActiveClass || 'bl-dot--active';
      dots.forEach(function (d, i) {
        d.classList.toggle(cls, i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    function paintArrows() {
      var hide = max() === 0;
      if (opts.prev) opts.prev.style.display = hide ? 'none' : '';
      if (opts.next) opts.next.style.display = hide ? 'none' : '';
    }

    function commit() {
      /* pixels, not percent: the slide width changes freely per breakpoint */
      track.style.transform = 'translateX(' + (-current * step()) + 'px)';
      paintDots();
      paintArrows();
      if (typeof opts.onChange === 'function') opts.onChange(current);
    }

    function buildDots() {
      var host = opts.dots;
      if (!host) return;
      var count = max() + 1;
      host.innerHTML = '';
      dots = [];
      if (count <= 1) return;        /* nothing to navigate between */
      for (var i = 0; i < count; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = opts.dotClass || 'bl-dot';
        b.setAttribute('aria-label', (opts.dotLabel || 'Go to position ') + (i + 1));
        b.dataset.index = i;
        b.addEventListener('click', function () {
          var idx = parseInt(this.dataset.index, 10);
          bump(function () { go(idx); });
        });
        host.appendChild(b);
        dots.push(b);
      }
      paintDots();
    }

    /* ---------- movement ---------- */

    /* One place decides what happens at the ends, so a swipe, an arrow, a dot
       and an autoplay tick all agree. BLSwipe commits an absolute index, so
       clamping here while next() looped was the reason a swipe stopped dead
       at the last slide while the arrows carried on round. */
    function go(i) {
      var m = max();
      if (i < 0)      i = loop ? m : 0;
      else if (i > m) i = loop ? 0 : m;
      current = i;
      commit();
    }

    function next() { go(current + 1); }
    function prev() { go(current - 1); }

    /* ---------- autoplay ----------
       Timer discipline lifted from announcement-bar.liquid: clear before
       every set so two timers can never stack, and any interaction restarts
       the interval so the next auto-advance is a full interval away instead
       of landing immediately after a manual move. */
    function start() {
      if (!autoplay || max() === 0) return;
      stop();
      timer = setInterval(next, speed);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function bump(fn) { stop(); fn(); start(); }

    /* ---------- re-measure ---------- */

    function refresh() {
      buildDots();
      if (current > max()) current = max();
      commit();
    }

    /* ---------- wiring ---------- */

    if (opts.prev) opts.prev.addEventListener('click', function () { bump(prev); });
    if (opts.next) opts.next.addEventListener('click', function () { bump(next); });

    if (autoplay && root) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('touchstart', stop, { passive: true });
      root.addEventListener('touchend', start, { passive: true });
    }

    var api = {
      get:  function () { return current; },
      max:  max,
      go:   function (i) { bump(function () { go(i); }); },
      step: step,
      wrap: wrap,
      next: next,
      prev: prev,
      start: start,
      stop: stop,
      refresh: refresh
    };

    if (window.BLSwipe && viewport) window.BLSwipe(viewport, track, api);

    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(refresh, 120);
    });

    buildDots();
    commit();
    start();

    return api;
  };
})();

/* ===== SITE-WIDE FUNCTIONS ===== */
(function() {
  'use strict';

  // ===== Sticky header shadow =====
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  // ===== Mobile menu drawer =====
  const menuToggle   = document.querySelector('[data-menu-toggle]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const mobileClose  = document.querySelector('[data-drawer-close]');

  function openMobileDrawer()  { if (mobileDrawer) mobileDrawer.classList.add('open');    document.body.style.overflow = 'hidden'; }
  function closeMobileDrawer() { if (mobileDrawer) mobileDrawer.classList.remove('open'); document.body.style.overflow = ''; }

  if (menuToggle)   menuToggle.addEventListener('click', openMobileDrawer);
  if (mobileClose)  mobileClose.addEventListener('click', closeMobileDrawer);
  if (mobileDrawer) mobileDrawer.addEventListener('click', function(e) { if (e.target === mobileDrawer) closeMobileDrawer(); });

  // ===== Cart count updater =====
  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const el = document.querySelector('[data-cart-count]');
        if (el) {
          if (cart.item_count > 0) {
            el.textContent = cart.item_count;
            el.style.display = 'block';
          } else {
            el.style.display = 'none';
          }
        }
      })
      .catch(function() {});
  }
  updateCartCount();
  window.updateCartCount = updateCartCount;

  // ===== Cart line item quantity update (cart page) =====
  document.querySelectorAll('[data-cart-qty-input]').forEach(function(input) {
    input.addEventListener('change', function() {
      const key = input.getAttribute('data-key');
      const qty = parseInt(input.value, 10) || 1;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function() { window.location.reload(); })
      .catch(function() {});
    });
  });

  // ===== Remove cart item (cart page) =====
  document.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const key = btn.getAttribute('data-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function() { window.location.reload(); })
      .catch(function() {});
    });
  });

})();

/* =========================================================================
   BLMoney — prices and the free-shipping threshold in the shopper's currency
   (29 Sept). Top level on purpose, like BLSwipe: the product IIFE below
   returns early off product pages, and the announcement bar needs this on
   every page.

   Why: markets now sell in AUD / CAD / GBP / USD. formatMoney used to
   hard-code '$', so a GBP cart drawer read "$31", and the free-shipping
   threshold (4900, US cents) was compared with the cart total in the
   shopper's own currency, so the Canada site said "unlocked" at CA$49
   while checkout only waives shipping at the CAD equivalent of US$49.

   Shopify exposes the live rate as Shopify.currency.rate (shop currency ->
   shopper currency). convert() rounds UP to a whole unit so the site never
   announces free shipping before checkout grants it. Read lazily: the
   Shopify object comes from content_for_header, which is always earlier in
   the page, but reading at call time costs nothing and cannot race.
   ========================================================================= */
window.BLMoney = (function () {
  'use strict';

  function currency() {
    var c = window.Shopify && window.Shopify.currency;
    return (c && c.active) || 'USD';
  }
  function rate() {
    var c = window.Shopify && window.Shopify.currency;
    var r = c ? parseFloat(c.rate) : NaN;
    return r > 0 ? r : 1;
  }

  var cache = {};
  function formatter(code, whole) {
    var key = code + (whole ? ':0' : ':2');
    if (cache[key]) return cache[key];
    var opts = { style: 'currency', currency: code };
    if (whole) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
    else       { opts.minimumFractionDigits = 2; opts.maximumFractionDigits = 2; }
    /* narrowSymbol gives "$58" for CAD, matching Shopify's own price format.
       Older browsers without it fall back to "CA$58", which is still right. */
    try { opts.currencyDisplay = 'narrowSymbol'; cache[key] = new Intl.NumberFormat('en', opts); }
    catch (e) {
      try { delete opts.currencyDisplay; cache[key] = new Intl.NumberFormat('en', opts); }
      catch (e2) { cache[key] = null; }
    }
    return cache[key];
  }

  /* Cents in the shopper's currency -> display string, in Shopify's "with
     currency" style: "$87.00 CAD", "£46.00 GBP" (30 Sept). Matches what the
     Liquid money_with_currency filter prints, so a price redrawn by JS (variant
     change, cart drawer) looks identical to the one the page loaded with.
     trimZeros drops ".00" on whole amounts — used for the free-shipping
     threshold ("$71 CAD"), never for prices. */
  function format(cents, trimZeros) {
    cents = Number(cents);
    if (isNaN(cents)) cents = 0;
    var amount = cents / 100;
    var whole = !!trimZeros && Math.round(cents) % 100 === 0;
    var code = currency();
    var f = formatter(code, whole);
    var text = f ? f.format(amount) : '$' + (whole ? amount.toFixed(0) : amount.toFixed(2));
    return text + ' ' + code;
  }

  /* Shop-currency cents (US$) -> shopper-currency cents, rounded up to a
     whole unit. US$ in, US$ out when no conversion applies. */
  function convert(baseCents) {
    var c = Math.ceil((Number(baseCents) || 0) * rate() / 100) * 100;
    return c;
  }

  /* Fill every [data-free-ship-amount] placeholder (announcement bar
     [free_shipping] token, product trust badge). Each carries its own
     base amount in data-base-cents, from Theme settings → Free shipping.
     No amount, no update (20 Oct): a hard-coded fallback here once meant a
     second copy of the threshold that could go stale. */
  function fillFreeShipping(root) {
    var els = (root || document).querySelectorAll('[data-free-ship-amount]');
    for (var i = 0; i < els.length; i++) {
      var base = parseInt(els[i].getAttribute('data-base-cents'), 10);
      if (!(base > 0)) continue;
      els[i].textContent = format(convert(base), true);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fillFreeShipping(); });
  } else {
    fillFreeShipping();
  }

  return { format: format, convert: convert, fillFreeShipping: fillFreeShipping };
})();

/* =========================================================================
   CART PAGE — free-shipping progress (12 Oct)
   Own IIFE at top level: the product block below returns early off product
   pages, which is why the cart page never had this bar. Same wording and
   classes as the product page bar.

   The cart total comes from Liquid (data-cart-total, shopper's currency,
   cents) — no fetch needed, because quantity changes and removals on the
   cart page reload it. The threshold setting is US cents and is converted
   with BLMoney.convert (rounded up), exactly as on the product page.
   ========================================================================= */
(function () {
  'use strict';
  var box = document.querySelector('[data-cart-shipping]');
  if (!box || !window.BLMoney) return;

  var total     = parseInt(box.getAttribute('data-cart-total'), 10) || 0;
  var base      = parseInt(box.getAttribute('data-base-cents'), 10);
  if (!(base > 0)) return;   /* no threshold: bar stays hidden */
  var threshold = window.BLMoney.convert(base);
  if (!threshold) return;

  var text = box.querySelector('[data-cart-shipping-text]');
  var bar  = box.querySelector('[data-cart-shipping-bar]');
  var fill = box.querySelector('[data-cart-shipping-fill]');
  var pct  = Math.min(100, Math.round((total / threshold) * 100));
  var msg;

  if (total >= threshold) {
    box.classList.add('shipping-progress--complete');
    msg = '\uD83C\uDF89 You\'ve unlocked free shipping!';
  } else {
    msg = 'Add ' + window.BLMoney.format(threshold - total, true) + ' more for free shipping';
  }

  if (text) text.textContent = msg;
  if (fill) fill.style.width = pct + '%';
  if (bar)  bar.setAttribute('aria-valuenow', pct);
  box.hidden = false;
})();

/* =========================================
   BEST LEARNING — Product Page JS v3
   Replaces the product IIFE in theme_clean.js
   ========================================= */
(function() {
  if (!document.querySelector('.product-page')) return;

  /* Currency-aware since 29 Sept — see BLMoney at top level. */
  function formatMoney(cents) { return window.BLMoney.format(cents); }
  /* Free-shipping messages: whole amounts without ".00" ("Add $71 CAD"). */
  function formatShipMoney(cents) { return window.BLMoney.format(cents, true); }
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  /* ===== ELEMENTS ===== */
  const mainImg         = qs('#productMainImg');
  const mainWrap        = qs('#productMainImageWrap');
  const zoomLens        = qs('#zoomLens');
  const zoomResult      = qs('#zoomResult');
  const thumbs          = qsa('.product-thumb');
  const variantIdInput  = qs('[data-variant-id]');
  const priceEl         = qs('[data-product-price]');
  const compareEl       = qs('[data-compare-price]');
  const saveBadge       = qs('[data-save-badge]');
  const skuEl           = qs('[data-sku]');
  const atcBtn          = qs('[data-add-to-cart]');
  const buyNowBtn       = qs('[data-buy-now]');
  const inventoryEl     = qs('[data-inventory-status]');
  const stickyBar       = qs('#productStickyBar');
  const stickyPrice     = qs('[data-sticky-price]');
  const stickyAtc       = qs('[data-sticky-atc]');
  const stickyShipping  = qs('[data-sticky-shipping]');
  const qtyInput        = qs('[data-quantity]');
  const qtyAlert        = qs('[data-qty-alert]');
  const shareBtn        = qs('[data-share-toggle]');
  const shareDropdown   = qs('[data-share-dropdown]');
  const copyLinkBtn     = qs('[data-copy-link]');
  const cartDrawer      = qs('#cartDrawer');
  const drawerOverlay   = qs('[data-drawer-overlay]');
  const cartDrawerClose = qs('#cartDrawer [data-drawer-close]');
  const drawerItems     = qs('[data-drawer-items]');
  const drawerFooter    = qs('[data-drawer-footer]');
  const drawerSubtotal  = qs('[data-drawer-subtotal]');
  const drawerShipping  = qs('[data-drawer-shipping]');

  /* US-cent setting converted to the shopper's currency (rounded up), so it
     compares like-for-like with cart totals, which Shopify gives in that currency.
     0 when the setting is missing: the progress bar and drawer line then stay
     blank rather than showing a guessed amount. */
  const threshold     = window.BLMoney.convert(Number(window.freeShippingThreshold) || 0);
  const b2bPageUrl    = window.b2bPageUrl || '/pages/manufacturing';

  /* ===== HOVER ZOOM ===== */
  var zoomActive = false;
  var currentZoomSrc = mainImg ? mainImg.dataset.zoomSrc || mainImg.src : '';

  function setupZoom(imgEl, zoomSrc) {
    if (!mainWrap || !zoomLens || !zoomResult || window.innerWidth < 800) return;
    currentZoomSrc = zoomSrc || imgEl.src;

    var bg = new Image();
    bg.src = currentZoomSrc;

    // v4 fix (bug 1): the gallery column is position:sticky, which creates its own
    // stacking context and traps the magnified panel behind the purchase panel.
    // Re-parenting the panel onto <body> frees it; z-index 90 keeps it above the
    // page but below the sticky header (z-index 100).
    if (zoomResult.parentElement !== document.body) document.body.appendChild(zoomResult);
    zoomResult.style.zIndex = '90';

    mainWrap.addEventListener('mouseenter', onZoomEnter);
    mainWrap.addEventListener('mousemove',  onZoomMove);
    mainWrap.addEventListener('mouseleave', onZoomLeave);
  }

  function onZoomEnter() {
    if (window.innerWidth < 800) return;
    /* Zoom reads pixels out of an <img>. When the main slot is showing a video
       there is nothing for it to magnify, and the lens would sit on top of the
       player's controls. Guarding here rather than unbinding keeps the handler
       set-up-once-at-load, which is what the rest of this block assumes. */
    if (mainWrap.dataset.mediaType === 'video') return;
    var rect = mainWrap.getBoundingClientRect();
    var lensW = Math.round(rect.width * 0.3);
    var lensH = Math.round(rect.height * 0.3);
    zoomLens.style.width  = lensW + 'px';
    zoomLens.style.height = lensH + 'px';

    var resultW = Math.min(400, rect.width);
    var resultH = Math.min(400, rect.height);
    zoomResult.style.width  = resultW + 'px';
    zoomResult.style.height = resultH + 'px';
    zoomResult.style.backgroundImage  = 'url(' + currentZoomSrc + ')';
    zoomResult.style.backgroundRepeat = 'no-repeat';

    var scaleX = resultW / lensW;
    var scaleY = resultH / lensH;
    zoomResult.style.backgroundSize = (rect.width * scaleX) + 'px ' + (rect.height * scaleY) + 'px';

    var galleryRect = mainWrap.closest('.product-gallery').getBoundingClientRect();
    var layoutEl    = mainWrap.closest('.product-layout');
    var layoutRect  = layoutEl ? layoutEl.getBoundingClientRect() : galleryRect;

    // v4 fix (bug 1): float the panel in the empty margin to the RIGHT of the whole
    // two-column layout so it stops landing on top of the title/price. If the margin
    // is too narrow, fall back to just-right-of-image, then pin inside the viewport.
    var left = layoutRect.right + 16;
    if (left + resultW > window.innerWidth - 8) left = galleryRect.right + 12;
    if (left + resultW > window.innerWidth - 8) left = window.innerWidth - resultW - 8;
    if (left < 8) left = 8;

    var top = galleryRect.top;
    if (top + resultH > window.innerHeight - 8) top = window.innerHeight - resultH - 8;
    if (top < 8) top = 8;

    zoomResult.style.position = 'fixed';
    zoomResult.style.top      = top + 'px';
    zoomResult.style.left     = left + 'px';

    zoomLens.classList.add('active');
    zoomResult.classList.add('active');
    zoomActive = true;
  }

  function onZoomMove(e) {
    if (!zoomActive) return;
    var rect   = mainWrap.getBoundingClientRect();
    var lensW  = zoomLens.offsetWidth;
    var lensH  = zoomLens.offsetHeight;
    var x = e.clientX - rect.left - lensW / 2;
    var y = e.clientY - rect.top  - lensH / 2;
    x = Math.max(0, Math.min(x, rect.width  - lensW));
    y = Math.max(0, Math.min(y, rect.height - lensH));
    zoomLens.style.left = x + 'px';
    zoomLens.style.top  = y + 'px';

    var resultW = zoomResult.offsetWidth;
    var resultH = zoomResult.offsetHeight;
    var scaleX  = resultW / lensW;
    var scaleY  = resultH / lensH;
    zoomResult.style.backgroundPosition = '-' + (x * scaleX) + 'px -' + (y * scaleY) + 'px';
  }

  function onZoomLeave() {
    zoomLens.classList.remove('active');
    zoomResult.classList.remove('active');
    zoomActive = false;
  }

  if (mainImg) setupZoom(mainImg, mainImg.dataset.zoomSrc);

  /* ===== GALLERY THUMBNAILS ===== */
  function setMainImage(src, zoomSrc, alt) {
    if (!mainImg) return;
    mainImg.src = src;
    mainImg.dataset.zoomSrc = zoomSrc || src;
    if (alt) mainImg.alt = alt;
    currentZoomSrc = zoomSrc || src;
    if (zoomResult) zoomResult.style.backgroundImage = 'url(' + currentZoomSrc + ')';
  }

  /* Video panels are rendered by Liquid as siblings of the main <img>, one per
     video in product.media, hidden until selected. Swapping by display rather
     than rebuilding means a part-watched video is still part-watched when you
     come back to it. */
  var mainVideos = mainWrap ? qsa('.product-main-video', mainWrap) : [];

  function pauseAllVideos() {
    Array.prototype.forEach.call(mainVideos, function (panel) {
      var v = panel.querySelector('video');
      if (v && !v.paused) v.pause();
      /* An external embed keeps playing behind a hidden panel and there is no
         cross-origin way to pause it, so the iframe is discarded instead. */
      var f = panel.querySelector('iframe');
      if (f) f.remove();
    });
  }

  function showMainMedia(index, isVideo) {
    if (!mainWrap) return;
    pauseAllVideos();

    Array.prototype.forEach.call(mainVideos, function (panel) {
      panel.hidden = String(panel.dataset.mainMedia) !== String(index);
    });

    if (mainImg) mainImg.hidden = !!isVideo;
    mainWrap.dataset.mediaType = isVideo ? 'video' : 'image';
    if (isVideo && zoomLens)   zoomLens.classList.remove('active');
    if (isVideo && zoomResult) zoomResult.classList.remove('active');

    if (!isVideo) return;

    var panel = mainWrap.querySelector('.product-main-video[data-main-media="' + index + '"]');
    if (!panel) return;

    var v = panel.querySelector('video');
    if (v) { v.setAttribute('playsinline', ''); return; }

    /* external_video — built on demand so no third-party iframe loads until the
       shopper actually asks for it. */
    var host = panel.dataset.externalHost;
    var id   = panel.dataset.externalId;
    if (!host || !id || panel.querySelector('iframe')) return;
    var url = host === 'vimeo'
      ? 'https://player.vimeo.com/video/' + id
      : 'https://www.youtube.com/embed/' + id;
    var f = document.createElement('iframe');
    f.src = url;
    f.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('title', 'Product video');
    panel.appendChild(f);
  }

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(t => t.classList.remove('product-thumb--active'));
      thumb.classList.add('product-thumb--active');

      var type    = thumb.dataset.mediaType || 'image';
      var isVideo = (type === 'video' || type === 'external_video');

      if (!isVideo) {
        var alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
        setMainImage(thumb.dataset.src, thumb.dataset.zoomSrc, alt);
      }
      showMainMedia(thumb.dataset.thumbIndex, isVideo);
    });
  });

  /* Opening state. Liquid already hides the image and unhides the right panel when
     media[0] is a video, so this is not about avoiding a flash — it is that an
     external embed has no iframe until something builds one, and nothing had.
     Driving it off the active thumbnail keeps one source of truth. */
  (function initMainMedia() {
    Array.prototype.forEach.call(mainVideos, function (panel) {
      var v = panel.querySelector('video');
      if (v) v.setAttribute('playsinline', '');
    });
    var opening = document.querySelector('.product-thumb--active');
    if (!opening) return;
    var t = opening.dataset.mediaType || 'image';
    if (t === 'video' || t === 'external_video') {
      showMainMedia(opening.dataset.thumbIndex, true);
    }
  })();

  /* Shopify's "Insert video" dialog stores whatever snippet was pasted, and a
     snippet trimmed to <iframe width height src title> has no allowfullscreen —
     which is why a description embed offers no fullscreen button while the A+
     module embed, which sets the attribute in Liquid, does. Normalising here
     rather than asking every product to be re-pasted correctly. The attribute
     is only honoured from load, so the src is re-assigned to apply it; harmless
     at page load because nothing is playing yet. */
  qsa('.tab-panel-rte iframe').forEach(function (f) {
    var src = f.getAttribute('src') || '';
    if (!/youtube\.com|youtu\.be|player\.vimeo\.com/.test(src)) return;
    if (f.hasAttribute('allowfullscreen')) return;
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    f.setAttribute('src', src);
  });

  /* REMOVED (see stage notes): a resize handler here paused hidden gallery media
     to stop the desktop and mobile players sounding at once after a rotation
     crossed the 800px breakpoint. It is withdrawn because entering fullscreen on
     Android auto-rotates the device, which fires that same resize — and pausing
     a fullscreen video exits fullscreen, while re-assigning an iframe src
     reloads it. Both "stuck fullscreen" reports appeared in the push that added
     it. Duo-playing is the lesser fault, and any replacement must prove it
     cannot run during a fullscreen transition: document.fullscreenElement is not
     set for Android's native video fullscreen, so it is not a sufficient guard
     on its own. */

  /* Desktop gallery arrows — drive the same thumbnail state, and wrap around.
     stopPropagation matters: the whole wrap opens the lightbox on click. */
  (function () {
    var pgPrev = qs('[data-pg-prev]');
    var pgNext = qs('[data-pg-next]');
    if ((!pgPrev && !pgNext) || thumbs.length < 2) return;

    function activeIndex() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('product-thumb--active')) return i;
      }
      return 0;
    }

    function step(delta, e) {
      e.preventDefault();
      e.stopPropagation();
      var i = (activeIndex() + delta + thumbs.length) % thumbs.length;
      thumbs[i].click();
      /* scrollIntoView() was removed with the switch to a wrapped thumbnail row.
         It existed to drag a horizontally scrolling strip along; with no
         horizontal overflow left it would scroll the page instead. */
    }

    if (pgPrev) pgPrev.addEventListener('click', function (e) { step(-1, e); });
    if (pgNext) pgNext.addEventListener('click', function (e) { step(1, e); });
  })();


  /* Unit toggle removed in v5 — Quick specs now shows both in/lb and cm/kg inline */

  /* ===== VARIANTS ===== */
  function getSelectedOptions() {
    var opts = {};
    qsa('.variant-options').forEach(function(group) {
      var sel = group.querySelector('.variant-option--selected');
      if (sel) opts[parseInt(group.dataset.optionIndex)] = sel.dataset.value;
    });
    return opts;
  }

  function findVariant(selectedOptions) {
    return (window.productVariants || []).find(function(v) {
      return Object.keys(selectedOptions).every(function(idx) {
        return v['option' + (parseInt(idx) + 1)] === selectedOptions[idx];
      });
    });
  }

  function updateInventoryBadge(variant) {
    if (!inventoryEl) return;
    var inStock = variant.available;
    var qty = variant.inventory_quantity;
    var html = '';
    if (inStock) {
      if (qty > 0 && qty <= 10) {
        html = '<span class="inv-badge inv-badge--low-stock"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> Only ' + qty + ' left</span>';
      } else {
        html = '<span class="inv-badge inv-badge--in-stock"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg> In stock</span>';
      }
    } else {
      html = '<span class="inv-badge inv-badge--out-of-stock"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> Out of stock</span>';
    }
    inventoryEl.innerHTML = html;
  }

  function updateDiscountTable(qty) {
    qsa('.qty-discount-row').forEach(function(row) {
      var min = parseInt(row.dataset.qtyMin) || 0;
      row.classList.remove('qty-discount-row--active');
    });
    var rows = qsa('.qty-discount-row');
    var active = null;
    rows.forEach(function(row) {
      var min = parseInt(row.dataset.qtyMin) || 0;
      if (qty >= min) active = row;
    });
    if (active) active.classList.add('qty-discount-row--active');
  }

  function updateVariantUI(variant) {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl)    priceEl.textContent    = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (skuEl && variant.sku) skuEl.textContent = variant.sku;

    if (compareEl) {
      var hasCompare = variant.compare_at_price > variant.price;
      compareEl.style.display = hasCompare ? '' : 'none';
      if (hasCompare) compareEl.textContent = formatMoney(variant.compare_at_price);
      if (saveBadge) {
        saveBadge.style.display = hasCompare ? '' : 'none';
        if (hasCompare) saveBadge.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
      }
    }

    var available = variant.available;
    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.innerHTML = available
        ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.98 1.61h9.72a2 2 0 001.98-1.71l1.6-8.69H6"/></svg> Add to Cart'
        : 'Out of Stock';
    }
    if (buyNowBtn) buyNowBtn.style.display = available ? '' : 'none';
    if (stickyAtc) stickyAtc.disabled = !available;
    if (qtyInput)  qtyInput.dataset.max = variant.inventory_quantity;

    updateInventoryBadge(variant);
    if (variant.featured_image && mainImg) setMainImage(variant.featured_image.src, variant.featured_image.src);
  }

  qsa('.variant-option').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.closest('.variant-options');
      if (group) group.querySelectorAll('.variant-option').forEach(function(b) { b.classList.remove('variant-option--selected'); });
      btn.classList.add('variant-option--selected');
      var idx = btn.dataset.optionIndex;
      var label = qs('[data-option-selected="' + (parseInt(idx) + 1) + '"]');
      if (label) label.textContent = btn.dataset.value;
      if (btn.dataset.variantImage) setMainImage(btn.dataset.variantImage, btn.dataset.variantImage);
      var matched = findVariant(getSelectedOptions());
      if (matched) updateVariantUI(matched);
    });
  });

  /* ===== QUANTITY (dropdown is capped at min(inventory,30), so it only drives the discount-tier highlight) ===== */
  function validateQty(val) {
    updateDiscountTable(val);
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function() { validateQty(parseInt(qtyInput.value) || 1); });
    validateQty(parseInt(qtyInput.value) || 1);
  }

  /* ===== SHIPPING PROGRESS ===== */
  var progressFill = qs('[data-shipping-fill]');
  var progressText = qs('[data-shipping-text]');
  var progressEl   = qs('[data-shipping-progress]');

  function updateShippingProgress(cartTotal) {
    if (!progressEl || !threshold) return;
    var pct = Math.min(100, Math.round((cartTotal / threshold) * 100));
    if (progressFill) progressFill.style.width = pct + '%';
    var msg, sticky = '';
    if (cartTotal >= threshold) {
      progressEl.classList.add('shipping-progress--complete');
      msg    = '🎉 You\'ve unlocked free shipping!';
      sticky = '🎉 Free shipping!';
    } else if (cartTotal === 0) {
      msg    = 'Add ' + formatShipMoney(threshold) + ' to unlock free shipping';
      sticky = 'Add ' + formatShipMoney(threshold) + ' for free shipping';
    } else {
      var rem = formatShipMoney(threshold - cartTotal);
      msg    = 'Add ' + rem + ' more for free shipping';
      sticky = 'Add ' + rem + ' for free shipping';
    }
    if (progressText)   progressText.textContent   = msg;
    if (stickyShipping) stickyShipping.textContent = sticky;
    if (drawerShipping) drawerShipping.textContent = cartTotal >= threshold
      ? '🎉 Free shipping unlocked!'
      : 'Add ' + formatShipMoney(threshold - cartTotal) + ' for free shipping';
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .catch(function() { return { total_price: 0, items: [] }; });
  }

  fetchCart().then(function(cart) { updateShippingProgress(cart.total_price); });

  /* ===== CART DRAWER ===== */
  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function() { cartDrawer.classList.add('open'); });
    renderCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(function() { cartDrawer.hidden = true; }, 280);
  }

  /* Paint the drawer from an authoritative cart object (used by both initial render and change responses) */
  function paintCart(cart) {
    if (!drawerItems) return;
    updateShippingProgress(cart.total_price);

    if (!cart.items || cart.items.length === 0) {
      drawerItems.innerHTML = '<div class="cart-drawer-empty"><p style="margin-bottom:14px">Your cart is empty.</p><a href="' + ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'collections/all-products" class="btn btn-outline btn-small">Shop now</a></div>';
      if (drawerFooter) drawerFooter.hidden = true;
      return;
    }

    drawerItems.innerHTML = '';
    cart.items.forEach(function(item) {
      var el = document.createElement('div');
      el.className = 'cart-drawer-item';
      el.dataset.key = item.key;
      el.innerHTML =
        '<div class="cart-drawer-item-img"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></div>' +
        '<div>' +
          '<div class="cart-drawer-item-title">' + item.product_title + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-drawer-item-variant">' + item.variant_title + '</div>' : '') +
          '<div class="cart-drawer-item-qty">' +
            '<button class="cart-drawer-qty-btn" data-drawer-qty-change data-key="' + item.key + '" data-delta="-1" aria-label="Decrease quantity">−</button>' +
            '<span class="cart-drawer-qty-num" data-item-qty>' + item.quantity + '</span>' +
            '<button class="cart-drawer-qty-btn" data-drawer-qty-change data-key="' + item.key + '" data-delta="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-drawer-item-price" data-item-price>' + formatMoney(item.final_line_price) + '</div>';
      drawerItems.appendChild(el);
    });

    if (drawerFooter) {
      drawerFooter.hidden = false;
      if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
      if (drawerShipping && threshold) drawerShipping.textContent = cart.total_price >= threshold
        ? '🎉 Free shipping unlocked!'
        : 'Add ' + formatShipMoney(threshold - cart.total_price) + ' for free shipping';
    }

    bindDrawerQtyButtons();
  }

  /* Debounced + serialized line-qty changes — prevents the race that desynced the icon and produced $NaN */
  var cartSyncTimers = {};
  function syncLineQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      /* A valid cart response always has total_price; anything else (error body, throttle) → re-fetch the real cart */
      if (cart && typeof cart.total_price !== 'undefined') {
        paintCart(cart);
      } else {
        fetchCart().then(paintCart);
      }
      updateCartCount();
    })
    .catch(function() { fetchCart().then(paintCart); updateCartCount(); });
  }

  function bindDrawerQtyButtons() {
    drawerItems.querySelectorAll('[data-drawer-qty-change]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key   = btn.dataset.key;
        var delta = parseInt(btn.dataset.delta, 10) || 0;
        var row   = btn.closest('.cart-drawer-item');
        var qtyEl = row.querySelector('[data-item-qty]');
        var current = parseInt(qtyEl.textContent, 10);
        if (isNaN(current)) current = 1;
        var newQty = Math.max(0, current + delta);

        /* Optimistic number bump for snappiness (price/subtotal reconcile on server response) */
        qtyEl.textContent = newQty;

        /* Coalesce rapid clicks into ONE request carrying the final quantity */
        clearTimeout(cartSyncTimers[key]);
        cartSyncTimers[key] = setTimeout(function() { syncLineQty(key, newQty); }, 320);
      });
    });
  }

  function renderCartDrawer() {
    if (!drawerItems) return;
    if (drawerFooter) drawerFooter.hidden = true;
    fetchCart().then(paintCart);
  }

  if (drawerOverlay)   drawerOverlay.addEventListener('click', closeCartDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);

  /* ===== ADD TO CART ===== */
  function addToCart() {
    if (!atcBtn || atcBtn.disabled) return;
    var variantId = variantIdInput ? parseInt(variantIdInput.value) : null;
    var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    if (!variantId) return;

    atcBtn.disabled = true;
    atcBtn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      atcBtn.disabled = false;
      atcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.98 1.61h9.72a2 2 0 001.98-1.71l1.6-8.69H6"/></svg> Add to Cart';
      updateCartCount();
      openCartDrawer();
    })
    .catch(function() {
      atcBtn.disabled = false;
      atcBtn.innerHTML = 'Try again';
    });
  }

  if (atcBtn)   atcBtn.addEventListener('click', addToCart);
  if (stickyAtc) stickyAtc.addEventListener('click', addToCart);

  /* ===== BUY NOW ===== */
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function() {
      var input = qs('[data-variant-id]');
      if (input) window.location.href = '/cart/' + input.value + ':' + (qtyInput ? qtyInput.value || 1 : 1);
    });
  }

  /* ===== SERIES STRIP (server-rendered; hover swaps the main image, no fetch) ===== */
  qsa('[data-series-strip] .series-item').forEach(function(item) {
    var preview = item.getAttribute('data-preview-src');
    if (!preview || !mainImg) return;
    item.addEventListener('mouseenter', function() {
      if (window.innerWidth >= 800) {
        if (!mainImg.dataset.previewSrc) mainImg.dataset.previewSrc = mainImg.src;
        setMainImage(preview, preview);
      }
    });
    item.addEventListener('mouseleave', function() {
      if (mainImg.dataset.previewSrc) {
        setMainImage(mainImg.dataset.previewSrc, mainImg.dataset.previewSrc);
        delete mainImg.dataset.previewSrc;
      }
    });
  });

  /* ===== SHARE DROPDOWN ===== */
  function closeShareDropdown() {
    if (shareDropdown) shareDropdown.hidden = true;
    if (shareBtn) shareBtn.setAttribute('aria-expanded', 'false');
  }
  if (shareBtn && shareDropdown) {
    shareBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = shareDropdown.hidden;
      shareDropdown.hidden = !open;
      shareBtn.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', function(e) { if (!shareBtn.contains(e.target)) closeShareDropdown(); });
  }
  if (copyLinkBtn) {
    copyLinkBtn.addEventListener('click', function() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(copyLinkBtn.dataset.url).then(function() {
          copyLinkBtn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Copied!';
          setTimeout(function() {
            copyLinkBtn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg> Copy link';
          }, 2000);
        });
      }
    });
  }
  var igBtn = qs('[data-share-instagram]');
  if (igBtn) {
    igBtn.addEventListener('click', function() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href).then(function() {
          igBtn.textContent = 'Link copied — paste in Instagram!';
          setTimeout(function() {
            igBtn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg> Instagram';
          }, 2500);
        });
      }
    });
  }



  /* ===== STICKY BAR ===== */
  if (stickyBar && atcBtn) {
    stickyBar.hidden = false;
    new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { stickyBar.classList.toggle('visible', !e.isIntersecting); });
    }, { threshold: 0 }).observe(atcBtn);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeShareDropdown();
  });

})();

/* ===== SCROLL TO TOP =====
   Its own IIFE: the block above returns early on any page without
   .product-page, so anything inside it never runs on the homepage. */
(function () {
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'scroll-top';
  btn.setAttribute('aria-label', 'Back to top');
  btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" ' +
                  'stroke="currentColor" stroke-width="2.5" aria-hidden="true">' +
                  '<polyline points="18 15 12 9 6 15"/></svg>';

  function mount() {
    document.body.appendChild(btn);
    update();
  }

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    btn.blur();                 /* drop focus so it does not stay highlighted */
  });

  var ticking = false;

  function syncOffset() {
    /* looked up each time: the bar only exists on product pages */
    var bar = document.getElementById('productStickyBar');
    var lift = (bar && bar.classList.contains('visible')) ? bar.offsetHeight : 0;
    btn.style.setProperty('--scroll-top-lift', lift + 'px');
  }

  function update() {
    btn.classList.toggle('scroll-top--visible', window.scrollY > 600);
    syncOffset();
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });

  window.addEventListener('resize', syncOffset);

  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount);
})();

/* =========================================
   TABS + SHARED COLLAPSIBLES  —  top level
   -----------------------------------------
   Lifted out of the product IIFE when the tabs markup moved to
   sections/product-tabs.liquid. That IIFE returns early without .product-page,
   which is rendered by main-product.liquid — so anything left inside it would
   only run when a DIFFERENT section happened to be on the page.

   Collapsibles are shared: main-product.liquid (Shipping & Returns) and
   product-tabs.liquid (Q&A, module 08) both use [data-collapsible]. That is
   why it lives here rather than in either section's scope.
   ========================================= */
(function() {
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }


  /* ===== COLLAPSIBLES ===== */
  qsa('[data-collapsible]').forEach(function(block) {
    var toggle = block.querySelector('[data-collapsible-toggle]');
    var body   = block.querySelector('[data-collapsible-body]');
    if (!toggle || !body) return;
    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      body.hidden = expanded;
    });
  });

  if (!qs('[data-tab-bar]') && !qs('.product-tab-panel')) return;

  /* ===== TABS SECTION — jump-nav (v6) ===== */
  /* All tab panels are always in the page (not hidden/shown) — nav links and in-page
     shortcuts (Quick Specs "Full specs", rating row) just smooth-scroll to the section. */
  var tabBar = qs('[data-tab-bar]');
  var tabNavLinks = qsa('.tabs-nav-link');
  var tabPanels = qsa('.product-tab-panel');

  function scrollToPanel(name) {
    var panel = qs('[data-tab-panel="' + name + '"]');
    if (!panel) return;
    panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function setActiveTab(name) {
    tabNavLinks.forEach(function(link) {
      link.classList.toggle('is-active', link.dataset.tab === name);
    });
  }

  // In-content shortcuts (Quick Specs "Full specs" link, star-rating row → Reviews)
  qsa('[data-tab-link]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      setActiveTab(link.dataset.tabLink);
      scrollToPanel(link.dataset.tabLink);
    });
  });

  // Jump-nav bar itself — native anchor scroll is fine, but we intercept for the
  // smooth-scroll + scroll-margin offset consistency with the shortcuts above.
  tabNavLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      setActiveTab(link.dataset.tab);
      scrollToPanel(link.dataset.tab);
    });
  });

  // Scrollspy — tracks scroll position directly rather than watching a fixed
  // viewport band, so it works regardless of how short/tall a section is.
  // Includes a bottom-of-page override so the last tab always activates once
  // the user has scrolled all the way down, even if that last section is short.
  if (tabBar && tabPanels.length) {
    var panelList = Array.prototype.slice.call(tabPanels);
    var spyTicking = false;

    function updateActiveTab() {
      var navBarHeight = tabBar.offsetHeight || 0;
      var referenceLine = navBarHeight + 24;
      var atBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 4);

      var activeName = panelList[0].dataset.tabPanel;
      if (atBottom) {
        activeName = panelList[panelList.length - 1].dataset.tabPanel;
      } else {
        panelList.forEach(function(panel) {
          if (panel.getBoundingClientRect().top <= referenceLine) {
            activeName = panel.dataset.tabPanel;
          }
        });
      }

      setActiveTab(activeName);
      spyTicking = false;
    }

    window.addEventListener('scroll', function() {
      if (!spyTicking) {
        window.requestAnimationFrame(updateActiveTab);
        spyTicking = true;
      }
    }, { passive: true });

    updateActiveTab();
  }

  /* ===== DESCRIPTION TAB — Premium navigation carousel (module 06) =====
     Single-slide-per-view, landscape banner, dots + arrows. */
  /* Q&A (module 08) needs no new JS — it reuses [data-collapsible] above. */
  qsa('[data-pm-carousel]').forEach(function(carousel) {
    var track = carousel.querySelector('[data-pm-carousel-track]');
    var prevBtn = carousel.querySelector('[data-pm-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-pm-carousel-next]');
    var dotsContainer = carousel.querySelector('[data-pm-carousel-dots]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var total = slides.length;
    if (!track || total === 0) return;

    var current = 0;
    var dots = [];

    function slideStep() {
      return slides[0] ? slides[0].offsetWidth : 0;
    }

    function goTo(index) {
      /* wrap around so the carousel can start over at either end */
      if (index < 0) index = total - 1;
      if (index > total - 1) index = 0;
      current = index;
      /* pixels, not percent, so the peek slide width can change freely */
      track.style.transform = 'translateX(' + (-current * slideStep()) + 'px)';
      updateDots();
    }

    /* Centre the overlay arrows on the slide image rather than on the whole
       slide, which also contains the caption below the image. */
    function positionNav() {
      if (!prevBtn && !nextBtn) return;
      var img = track.querySelector('.pm-carousel-slide-image');
      var h = img ? img.offsetHeight : 0;
      if (h > 0) carousel.style.setProperty('--pm-nav-top', (h / 2) + 'px');
    }

    function updateDots() {
      dots.forEach(function(dot, i) {
        dot.classList.toggle('pm-carousel-dot--active', i === current);
      });
    }

    function buildDots() {
      if (!dotsContainer || total <= 1) return;
      dotsContainer.innerHTML = '';
      dots = [];
      for (var i = 0; i < total; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pm-carousel-dot' + (i === 0 ? ' pm-carousel-dot--active' : '');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function(idx) {
          btn.addEventListener('click', function() { goTo(idx); });
        })(i);
        dotsContainer.appendChild(btn);
        dots.push(btn);
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    buildDots();
    goTo(0);

    window.BLSwipe(carousel, track, {
      get: function () { return current; },
      max: function () { return total - 1; },
      go: goTo,
      step: slideStep,
      wrap: true
    });

    positionNav();
    window.addEventListener('load', positionNav);
    window.addEventListener('resize', function () {
      positionNav();
      goTo(current);            /* re-measure after a width change */
    });
    track.querySelectorAll('.pm-carousel-slide-image img').forEach(function(im) {
      if (!im.complete) im.addEventListener('load', positionNav);
    });
  });
})();

